























import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import ChangeLanguage from '@/mixins/ChangeLanguage';
import FetchLocations from '@/mixins/FetchLocations';
import Item from '@vuex-orm/core/lib/data/Item';
import LanguagePicker from '@/components/LanguagePicker.vue';
import LocationMap from '@/components/location/LocationMap.vue';
import LocationModel from '@/location/Location';
import MarkerContract from '@/marker/MarkerContract';
import LocationPanel from '@/components/location/location-panel/LocationPanel.vue';

const Markers = namespace('markers');
const Locations = namespace('locations');

@Component({
    components: {
        LocationPanel,
        LanguagePicker,
        LocationMap,
    },
})
export default class Location extends mixins(ChangeLanguage, FetchLocations) {
    @Markers.Getter
    activeMarker!: MarkerContract | null;

    @Markers.Getter
    activeMarkerCategory!: string | null;

    @Locations.Mutation
    setActiveLocationPanelItem!: (id: string | null) => void;

    @Markers.Mutation
    setActiveMarkerId!: (markerId: string | null) => void;

    @Markers.Mutation
    setActiveMarkerCategory!: (categoryId: string | null) => void;

    @Locations.Mutation
    toggleMobileMenu!: (isOpened?: boolean) => void;

    private get location(): Item<LocationModel> | undefined {
        const uuid = this.$route.params.location;

        return LocationModel.query()
            .withAllRecursive()
            .find(uuid);
    }

    private openStudiesPanel(id: string) {
        this.setActiveMarkerCategory(id);
        this.setActiveLocationPanelItem(id);
        this.toggleMobileMenu(true);
    }

    private resetActiveMarkerCategory() {
        this.setActiveMarkerCategory(null);
    }

    @Watch('$route.params.location', { immediate: true, deep: true })
    private onRouteChange(newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.setActiveLocationPanelItem(newValue);
            this.resetActiveMarkerCategory();
        }
    }
}
